import { render, staticRenderFns } from "./grasping_rules_stores.vue?vue&type=template&id=70766e4e&scoped=true&"
import script from "./grasping_rules_stores.vue?vue&type=script&lang=js&"
export * from "./grasping_rules_stores.vue?vue&type=script&lang=js&"
import style0 from "./grasping_rules_stores.vue?vue&type=style&index=0&id=70766e4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70766e4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70766e4e')) {
      api.createRecord('70766e4e', component.options)
    } else {
      api.reload('70766e4e', component.options)
    }
    module.hot.accept("./grasping_rules_stores.vue?vue&type=template&id=70766e4e&scoped=true&", function () {
      api.rerender('70766e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/kms_new/views/grasping_rules/form/components/grasping_rules_stores.vue"
export default component.exports